/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu-content[_ngcontent-%COMP%]{-ms-flex:0 0 auto;flex:0 0 auto}.menu-empty-space[_ngcontent-%COMP%], .menu-loading[_ngcontent-%COMP%]{-ms-flex:1 1 auto;flex:1 1 auto}.menu-version[_ngcontent-%COMP%]{-ms-flex:0 0 auto;flex:0 0 auto;font-size:.9em;padding:4px 24px;color:#8492a6;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"];
export { styles as styles };
